module.exports = __webpack_public_path__ + "static/media/thumbnail.100c3e7b.svg";